import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/contract-service/v1'

const SERVICE_URL1 = '/general-service/v1'


export function getContractById(params, pathParam) {
    return get(SERVICE_URL + '/contract/getContractID', params, pathParam)
}
export function getContractList(params) {
    return post(SERVICE_URL + '/contract/getContractList', params)
}
export function createContract(params) {
    return post(SERVICE_URL + '/contract/insertContract', params)
}
export function editContract(params) {
    return post(SERVICE_URL + '/contract/updateContract', params)
}
export function removeContract(params,pathParam) {
    return get(SERVICE_URL + '/contract/deleteContract', params,pathParam)
}
/** 获取当前登录人对应的采购组织 接口 } /position/getCurrentUserPurOrg*/
export function getCurrentUserPurOrg(params) {
    return get(SERVICE_URL1 + '/org/purList', params)
}